import { Button, ButtonProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { useFoldersContext } from '../../contexts/useFolders.context';

const intl = {
  newFolder: 'New Folder'
};

type CreateFolderButtonProps = {
  variant?: ButtonProps['variant'];
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

export function CreateFolderButton({
  variant = 'text',
  icon = <AddIcon />,
  children = intl.newFolder
}: CreateFolderButtonProps) {
  const { isCreateFolderDialogOpen, setIsCreateFolderDialogOpen } = useFoldersContext();

  return (
    <Button
      variant={variant}
      color="primary"
      startIcon={icon}
      data-test="createFolderButton"
      disabled={isCreateFolderDialogOpen}
      onClick={() => {
        setIsCreateFolderDialogOpen(true);
      }}
    >
      {children}
    </Button>
  );
}
